import { useState } from 'react';
import TestcasesTableToolbar from './TestcasesTableToolbar';
import { useURLParams } from '@shared/hooks/useURLParams';
import { TestcasesTable } from '@pages/testcases';

const TestcasesTableContainer = ({
    fullModuleName,
    moduleSelector,
    moduleIdForNavigateState,
    moduleNameFromUrlParams = undefined,
    setModuleNameFromUrlParams = undefined,
}) => {
    const [selectedTestCaseId, setSelectedTestCaseId] = useState(null);
    const [selectedTestPlanId, setSelectedTestPlanId] = useState(null);
    const [urlParams] = useURLParams();
    const [tagsSearch, setTagsSearch] = useState((urlParams.tags && JSON.parse(urlParams.tags)) || []);

    return (
        <TestcasesTable
            enableMultiRowSelection={false}
            toolbar={(table) => (
                <TestcasesTableToolbar
                    table={table}
                    selectedTestCaseId={selectedTestCaseId}
                    selectedTestPlanId={selectedTestPlanId}
                    setSelectedTestCaseId={setSelectedTestCaseId}
                    setSelectedTestPlanId={setSelectedTestPlanId}
                    moduleSelector={moduleSelector}
                    moduleIdForNavigateState={moduleIdForNavigateState}
                    moduleNameFromUrlParams={moduleNameFromUrlParams}
                    setModuleNameFromUrlParams={setModuleNameFromUrlParams}
                    tagsSearch={tagsSearch}
                    setTagsSearch={setTagsSearch}
                />
            )}
            setSelectedTestCaseId={setSelectedTestCaseId}
            fullModuleName={fullModuleName}
            moduleNameFromUrlParams={moduleNameFromUrlParams}
            tagsSearch={tagsSearch}
        />
    );
};

export default TestcasesTableContainer;
